export default __webpack_public_path__ + "static/media/pa.2c0b3330.svg";